import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { ReactNode } from 'react';
import { useAppContext } from '@/Main';
import { getColor } from '@/helpers/utils';

interface FalconLinkProps {
  to?: string;
  icon?: IconProp | 'chevron-right' | '';
  title?: ReactNode;
  className?: string;
  target?: string;
  decorative?: boolean;
}

const FalconLink = ({
  to = '#!',
  icon = 'chevron-right',
  title,
  className,
  target = '_self',
  decorative = false,
}: FalconLinkProps) => {
  const {
    config: { isRTL },
  } = useAppContext();

  const iconHandler = (iconName: IconProp | 'chevron-right'): IconProp => {
    if (iconName === 'chevron-right') {
      return isRTL ? 'chevron-left' : 'chevron-right';
    }
    return iconName;
  };

  return (
    <Button
      variant="link"
      size="sm"
      id="falconLinks"
      as={decorative ? 'span' : Link}
      {...(!decorative && { to, target })}
      className={className}
      style={{ color: getColor('navbar-vertical-default-link-active-color') }}
    >
      {title}
      {icon && (
        <FontAwesomeIcon
          style={{
            color: getColor('navbar-vertical-default-link-active-color'),
          }}
          icon={iconHandler(icon)}
          className="ms-1 fs--2"
        />
      )}
      <style>{`
      .falconLinks:hover{
border-color:blue !important;
      }`}</style>
    </Button>
  );
};

export default FalconLink;
